import apiV2 from "api-v2";

export interface AiImportColumn {
	label: string;
	detectedType: string;
}

export interface AiImportTable {
	name: string;
	columns: AiImportColumn[];
	rows: string[][];
}

export interface AiSpreadsheetImportPreview {
	tables: AiImportTable[];
	warnings?: string[];
	rowLimitReached?: boolean;
	maxRows?: number;
}

export interface AiImportSavePayload {
	tables: {
		name: string;
		columns: { name: string; type: string }[];
		rows: string[][];
	}[];
}

export const analyseSpreadsheet = async (
	rfxId: number,
	file: File
): Promise<AiSpreadsheetImportPreview> => {
	const formData = new FormData();
	formData.append("file", file);
	const response = await apiV2.post<{ data: AiSpreadsheetImportPreview }>(
		`rfx/${rfxId}/quotes/ai-import/analyze`,
		formData,
		{ headers: { "Content-Type": "multipart/form-data" } }
	);
	return response.data.data;
};

export const saveAiImportTables = async (
	rfxId: number,
	payload: AiImportSavePayload
): Promise<void> => {
	await apiV2.post(`rfx/${rfxId}/quotes/ai-import/apply`, payload);
};
